import { CommonModule } from '@angular/common'
import { Component, Input, LOCALE_ID, OnChanges, OnDestroy, SimpleChanges } from '@angular/core'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import moment from 'moment'
import { Subscription } from 'rxjs'
import { LocalChannel } from '../../../interfaces/local-channel'
import { LocalChannelLiveEPG } from '../../../interfaces/local-epg'
import { MomentPipe } from '../../../pipes/moment.pipe'

@Component({
  selector: 'app-channel-progress',
  standalone: true,
  imports: [CommonModule, MatProgressBarModule, MomentPipe],
  templateUrl: './channel-progress.component.html',
  styleUrls: ['./channel-progress.component.scss'],
  providers: [{ provide: LOCALE_ID, useFactory: () => moment.locale() }],
})
export class ChannelProgressComponent implements OnDestroy, OnChanges {
  liveEPGSubscription?: Subscription

  @Input() channel!: LocalChannel

  progressValue = 0

  constructor() {
    // do nothing
  }

  ngOnDestroy(): void {
    this.liveEPGSubscription?.unsubscribe()
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ngOnChanges(changes: SimpleChanges): void {
    this.registerLiveEPGSubscription()
  }

  registerLiveEPGSubscription(): void {
    this.liveEPGSubscription?.unsubscribe()
    this.liveEPGSubscription = this.channel.liveEPG$.subscribe((liveEPG: LocalChannelLiveEPG | undefined) => {
      this.updateProgressValue(liveEPG)
    })
  }

  updateProgressValue(liveEPG?: LocalChannelLiveEPG): void {
    if (liveEPG && liveEPG.currentProgram) {
      const now = new Date()
      const start = liveEPG?.currentProgram.start
      const end = liveEPG?.currentProgram.end
      const duration = Math.abs(end.getTime() - start.getTime())
      const elapsedTime = Math.abs(now.getTime() - start.getTime())
      this.progressValue = Math.round((elapsedTime / duration) * 100)
    }
  }
}
